import { createSelector } from 'reselect'

const getProperties = state => state.properties
const getHighlights = state => state.highlights

export const getDetailedHighlights = createSelector(
  [getProperties, getHighlights],
  (properties, results) => results.valueSeq().toArray()
)
